import React from 'react'

import { ApplicationLogo, ApplicationLogoKind } from 'Components/Blocks/_v2'

import { ROOT } from 'Constants/paths'

import { Container, Content, StyledLink } from './styles'

function Header() {
  return (
    <Container>
      <Content>
        <StyledLink href={ROOT} to={{ pathname: ROOT }}>
          <ApplicationLogo
            height={34}
            kind={ApplicationLogoKind.WideColor}
            width={135}
          />
        </StyledLink>
      </Content>
    </Container>
  )
}

export default Header
